module.exports = __webpack_public_path__ + "img/ss.197e56f8.svg";